import Regions from '../../pages/Regions'

export default function Panel() {
  return <Regions />
}
